// Only repair known display characters; leave valid names, symbols and other languages alone.
const displayCharacters = "\u00a0\u00a1\u00bf\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1\u00fc\u00dc\u00b7\u2022\u2013\u2014\u2018\u2019\u201c\u201d\u25be";
const windows1252 = "\u20ac\u0081\u201a\u0192\u201e\u2026\u2020\u2021\u02c6\u2030\u0160\u2039\u0152\u008d\u017d\u008f\u0090\u2018\u2019\u201c\u201d\u2022\u2013\u2014\u02dc\u2122\u0161\u203a\u0153\u009d\u017e\u0178";
const misreadUtf8 = (text, windows) => encodeURIComponent(text).replace(/%([\dA-F]{2})/g, (_, hex) => {
  const byte = parseInt(hex, 16);
  return windows && byte >= 128 && byte <= 159 ? windows1252[byte - 128] : String.fromCharCode(byte);
});
const replacements = new Map();
for (const character of displayCharacters) {
  let variants = new Set([character]);
  for (let depth = 0; depth < 3; depth += 1) {
    variants = new Set([...variants].flatMap(value => [misreadUtf8(value, true), misreadUtf8(value, false)]));
    for (const variant of variants) replacements.set(variant, character);
  }
}
const brokenCharacters = new RegExp([...replacements.keys()]
  .sort((a, b) => b.length - a.length)
  .map(value => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|"), "g");

export const repairTextEncoding = (value) =>
  String(value ?? "").replace(brokenCharacters, match => replacements.get(match));
